module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_9006.256a11a2.png";